import { render, staticRenderFns } from "./MyAddressList.vue?vue&type=template&id=5c7b717a&scoped=true&"
import script from "./MyAddressList.vue?vue&type=script&lang=ts&"
export * from "./MyAddressList.vue?vue&type=script&lang=ts&"
import style0 from "./MyAddressList.vue?vue&type=style&index=0&id=5c7b717a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b717a",
  null
  
)

export default component.exports